import React from "react";

function ContentCard({data}) {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <div className="contentcard">
      <div className="img">
        <img src={data.img} alt="" />
      </div>
      <div className="xtt">
        <h1>{data.name}</h1>
        <h2>{data.job}</h2>
        <p>E-pochta</p>
        <samp>{data.email}</samp>
        <p>Telefon raqami</p>
        <samp>+998 {data.number}</samp>
        <p>Ilmiy darajasi</p>
        <samp>{data.level}</samp>
        <p>Qabul vaqti</p>
        <samp>{data.time} <br />{data.clock}</samp>
      </div>
    </div>
  );
}

export default ContentCard;
